// Deposit Received / Thank You Email Generator

// HomeGo logo
const SUNNY_IMAGE_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

const generateDepositReceivedEmailHTML = (data) => {
  const {
    customer_name = "John Smith",
    quotation_reference = "HG-2024-001",
    move_date = "Monday, 15th January 2024",
    arrival_time = "8:00 AM - 9:00 AM",
    moving_from = "123 High Street, London, E1 6AN",
    moving_to = "456 Oak Road, Manchester, M1 2AB",
    selected_package = "comfort",
    total_amount = "485",
    deposit_received = "100",
    van_size = "Maxi Mover Van",
    crew_count = "2",
    phone_number = "0330 043 4791",
    // Consultant
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    consultant_image = SUNNY_IMAGE_URL,
    whats_next = "Our team will arrive between your scheduled time slot - please ensure someone is available to greet them\nHave all boxes sealed and items ready for loading to ensure a smooth start\nThe remaining balance of your move is due on the day - cash or bank transfer accepted\nLabel fragile items clearly so our team can handle them with extra care\nKeep essentials (documents, valuables, medications) with you separately\nContact us immediately if there are any last-minute changes to your move",
    our_commitment = "Your belongings will be handled with the utmost care and professionalism\nWe guarantee on-time arrival - if we're late, we'll make it right\nFully insured service with up to £50,000 goods in transit cover\nOur friendly, uniformed team will treat your home with respect\nNo hidden fees - the price we quote is the price you pay\nWe'll keep you informed throughout the entire moving process\nAll furniture will be wrapped and protected during transit",
    important_notes = "Please secure a parking spot for our van as close to your door as possible - this speeds up loading\nHave your keys ready and keep them with you at all times during the move\nIf you haven't received keys to your new property, contact your solicitor/estate agent BEFORE we arrive\nEnsure you have confirmed access time at your new address\nStay in contact with our office on 0330 043 4791 - we're here to help all day\nCheck all rooms, cupboards and the loft before we leave your old property\nTake meter readings at both properties for your records",
    bank_account_name = "HOMEGO REMOVALS & PACKING LTD",
    bank_sort_code = "23-05-80",
    bank_account_number = "57158107",
    payment_link = "",
    // Crew Recommendation
    booked_crew_count = "",
    booked_van_type = "",
    recommended_crew_count = "",
    recommended_van_type = "",
    crew_upgrade_cost = "150",
    show_crew_recommendation = false,

    // Working Hours & Overtime Policy
    show_overtime_policy = false,
    overtime_rate = "120",
    work_hours_start = "9:00 AM",
    work_hours_end = "5:00 PM",
    // Custom Message
    custom_recommendation_message = "",
    show_custom_message = false,
    // Multiple Locations
    pickup_location_1 = "",
    pickup_location_2 = "",
    dropoff_location_1 = "",
    dropoff_location_2 = "",
    stop_location_1 = "",
    stop_location_2 = "",
    show_extra_pickups = false,
    show_extra_dropoffs = false,
    show_stops = false,
    // Special Requirements
    special_requirements = "",
    show_special_requirements = false,
  } = data;

  // Calculate pending balance
  const pending = (parseFloat(total_amount) - parseFloat(deposit_received)).toFixed(2);

  // Package display names and colors
  const packageInfo = {
    loading_crew: { name: "Loading Crew Only", color: "#10B981", badge: "LABOUR ONLY", isHourly: true },
    man_and_van: { name: "Man & Van", color: "#3B82F6", badge: "HOURLY RATE", isHourly: true },
    economy: { name: "Economy Move", color: "#10B981", badge: "BUDGET-FRIENDLY", isHourly: false },
    comfort: { name: "Comfort Move", color: "#2563EB", badge: "RECOMMENDED", isHourly: false },
    comfort_plus: { name: "Complete Comfort Move", color: "#8B5CF6", badge: "MOST POPULAR", isHourly: false },
    premium: { name: "Premium Move", color: "#D4AF37", badge: "PREMIUM SERVICE", isHourly: false }
  };

  const pkg = packageInfo[selected_package] || packageInfo.comfort;
  const priceDisplay = pkg.isHourly ? `£${total_amount}/hr` : `£${total_amount}`;

  // Generate crew icons with emoji
  const crewCount = parseInt(crew_count) || 2;
  let crewIcons = '';
  for (let i = 0; i < crewCount; i++) {
    crewIcons += `
      <td style="padding: 0 4px; text-align: center;">
        <span style="font-size: 32px;">🧑‍🔧</span>
      </td>
    `;
  }

  // Crew Recommendation section (only show if enabled)
  // Working Hours & Overtime Policy section (only show if enabled)
  const overtimePolicyHTML = show_overtime_policy ? `
          <!-- Working Hours & Overtime Policy -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 12px; overflow: hidden; border: 2px solid #1a1a1a;">
                <tr>
                  <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 15px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 15px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      ⏰ Working Hours &amp; Overtime Policy
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #FAFAF7; padding: 20px;">
                    <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.7;">
                      Our crew's standard working day runs from <strong>${work_hours_start}</strong> to <strong>${work_hours_end}</strong>, in line with UK working practice for removals crews.
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF2F2; border: 1px solid #FCA5A5; border-radius: 8px;">
                      <tr>
                        <td style="padding: 12px 15px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #991B1B; line-height: 1.6;">
                            <strong>Overtime:</strong> Any work required after ${work_hours_end} is chargeable at <strong style="font-size: 16px;">£${overtime_rate} per hour</strong> (or part thereof), payable on the day.
                          </p>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #065F46; line-height: 1.6; background-color: #ECFDF5; border-radius: 8px; padding: 12px 15px;">
                      💡 <strong>Avoid overtime charges:</strong> booking the recommended crew size means your move completes comfortably within standard hours — faster, smoother, and no extra cost on the day.
                    </p>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #888; line-height: 1.5;">
                      By confirming your booking you accept these working hours and overtime terms, which form part of your agreement with HomeGo Removals &amp; Packing Ltd.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  const crewRecommendationHTML = show_crew_recommendation && booked_crew_count ? `
    <!-- Crew Upgrade Recommendation -->
    <tr>
      <td class="mobile-padding" style="padding: 0 30px 20px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF3C7; border: 2px solid #F59E0B; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #92400E; text-transform: uppercase; letter-spacing: 1px;">
                🚚 Crew Upgrade Recommendation
              </h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 10px; background-color: #FFF; border-radius: 6px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">
                      <strong>Your Current Booking:</strong><br/>
                      ${booked_crew_count} Crew Members + ${booked_van_type}
                    </p>
                  </td>
                </tr>
                <tr><td style="height: 10px;"></td></tr>
                <tr>
                  <td style="padding: 10px; background-color: #D1FAE5; border-radius: 6px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #065F46;">
                      <strong>💡 For a faster & smoother move we recommend:</strong><br/>
                      ${recommended_crew_count} Crew Members + ${recommended_van_type}
                    </p>
                    <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #047857;">
                      Extra Cost: +£${crew_upgrade_cost}
                    </p>
                    <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #047857;">
                      ⏱️ Save time & reduce stress with extra help!
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Custom Message section (only show if enabled and has content)
  const customMessageHTML = show_custom_message && custom_recommendation_message ? `
    <!-- Personal Message from HomeGo -->
    <tr>
      <td class="mobile-padding" style="padding: 0 30px 20px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F3E8FF; border: 2px solid #9333EA; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #7C3AED; text-transform: uppercase; letter-spacing: 1px;">
                💬 A Message From Our Team
              </h4>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                ${custom_recommendation_message}
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Multiple Locations HTML
  const hasExtraLocations = (show_extra_pickups && (pickup_location_1 || pickup_location_2)) || 
                           (show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2)) ||
                           (show_stops && (stop_location_1 || stop_location_2));
  
  const multipleLocationsHTML = hasExtraLocations ? `
    <!-- Multiple Locations -->
    <tr>
      <td class="mobile-padding" style="padding: 0 30px 20px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF7ED; border: 2px solid #F97316; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #C2410C; text-transform: uppercase; letter-spacing: 1px;">
                📍 Multiple Locations
              </h4>
              
              ${show_extra_pickups && (pickup_location_1 || pickup_location_2) ? `
              <div style="margin-bottom: 15px;">
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">PICKUP LOCATIONS:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  <strong>1.</strong> ${moving_from} (Main)<br/>
                  ${pickup_location_1 ? `<strong>2.</strong> ${pickup_location_1}<br/>` : ''}
                  ${pickup_location_2 ? `<strong>3.</strong> ${pickup_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
              
              ${show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2) ? `
              <div style="margin-bottom: 15px;">
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">DROP-OFF LOCATIONS:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  <strong>1.</strong> ${moving_to} (Main)<br/>
                  ${dropoff_location_1 ? `<strong>2.</strong> ${dropoff_location_1}<br/>` : ''}
                  ${dropoff_location_2 ? `<strong>3.</strong> ${dropoff_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
              
              ${show_stops && (stop_location_1 || stop_location_2) ? `
              <div>
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">STOPS ALONG THE WAY:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  ${stop_location_1 ? `<strong>Stop 1:</strong> ${stop_location_1}<br/>` : ''}
                  ${stop_location_2 ? `<strong>Stop 2:</strong> ${stop_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Special Requirements HTML
  const specialRequirementsHTML = show_special_requirements && special_requirements ? `
    <!-- Special Requirements -->
    <tr>
      <td class="mobile-padding" style="padding: 0 30px 20px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF1F2; border: 2px solid #F43F5E; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #BE123C; text-transform: uppercase; letter-spacing: 1px;">
                ⚠️ Special Requirements
              </h4>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                ${special_requirements}
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Deposit Received - HomeGo Removals</title>
  <style type="text/css">
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; }
      .mobile-padding { padding-left: 15px !important; padding-right: 15px !important; }
      .header-padding { padding: 15px 20px !important; }
      .content-padding { padding: 15px !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: Helvetica, Arial, sans-serif;">
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #f5f5f5;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <table class="email-container" border="0" cellpadding="0" cellspacing="0" width="600" style="max-width: 600px; width: 100%; background-color: #ffffff;">
          
          <!-- Header -->
          <tr>
            <td style="background-color: #000000; padding: 25px 40px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <h1 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 24px; font-weight: bold;">
                      <span style="color: #D4AF37;">HomeGo</span>
                      <span style="color: #FFFFFF;"> Removals</span>
                    </h1>
                    <p style="margin: 5px 0 0; font-size: 12px; color: #888888;">Professional Moving Services</p>
                  </td>
                  <td align="right">
                    <span style="background-color: #D4AF37; color: #000000; padding: 8px 16px; border-radius: 20px; font-size: 12px; font-weight: bold;">
                      REF: ${quotation_reference}
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Thank You Banner -->
          <tr>
            <td style="background: linear-gradient(135deg, #10B981 0%, #059669 100%); padding: 30px 40px; text-align: center;">
              <div style="font-size: 48px; margin-bottom: 10px;">🎉</div>
              <h2 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 28px; font-weight: bold; color: #FFFFFF;">
                Thank You for Your Deposit!
              </h2>
              <p style="margin: 10px 0 0; font-size: 16px; color: #D1FAE5;">
                Your booking is now secured
              </p>
            </td>
          </tr>

          <!-- Customer Details -->
          <tr>
            <td style="padding: 30px 40px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="background-color: #F3F4F6; border-radius: 10px; padding: 20px;">
                    <p style="margin: 0 0 5px; font-size: 12px; color: #6B7280; text-transform: uppercase; letter-spacing: 1px;">Customer</p>
                    <p style="margin: 0; font-size: 20px; font-weight: bold; color: #1F2937;">${customer_name}</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Package Selected -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #1F2937; border-radius: 10px; overflow: hidden;">
                <tr>
                  <td style="padding: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <span style="background-color: ${pkg.color}; color: #FFFFFF; padding: 4px 12px; border-radius: 12px; font-size: 10px; font-weight: bold;">
                            ${pkg.badge}
                          </span>
                          <h3 style="margin: 10px 0 0; font-size: 22px; font-weight: bold; color: #FFFFFF;">${pkg.name}</h3>
                        </td>
                        <td align="right">
                          <p style="margin: 0; font-size: 14px; color: #9CA3AF;">Your Package</p>
                          <p style="margin: 5px 0 0; font-size: 28px; font-weight: bold; color: #D4AF37;">${priceDisplay}</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Payment Summary -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <h3 style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #1F2937; text-transform: uppercase; letter-spacing: 1px;">
                💳 Payment Summary
              </h3>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #E5E7EB; border-radius: 10px; overflow: hidden;">
                <tr>
                  <td style="padding: 15px 20px; border-bottom: 1px solid #E5E7EB;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="font-size: 14px; color: #6B7280;">${pkg.isHourly ? 'Hourly Rate' : 'Total Amount'}</td>
                        <td align="right" style="font-size: 16px; font-weight: bold; color: #1F2937;">${priceDisplay}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 15px 20px; background-color: #D1FAE5; border-bottom: 1px solid #E5E7EB;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="font-size: 14px; color: #059669; font-weight: bold;">✓ Deposit Received</td>
                        <td align="right" style="font-size: 16px; font-weight: bold; color: #059669;">&pound;${deposit_received}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 15px 20px; background-color: #FEF3C7;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="font-size: 14px; color: #92400E; font-weight: bold;">${pkg.isHourly ? 'Balance Due (Based on Hours)' : 'Balance Due on Moving Day'}</td>
                        <td align="right" style="font-size: 18px; font-weight: bold; color: #92400E;">${pkg.isHourly ? 'Calculated on job completion' : `£${pending}`}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Move Details -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <h3 style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #1F2937; text-transform: uppercase; letter-spacing: 1px;">
                📦 Your Move Details
              </h3>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F9FAFB; border-radius: 10px; overflow: hidden;">
                <!-- Date & Time -->
                <tr>
                  <td style="padding: 20px; border-bottom: 1px solid #E5E7EB;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td width="50%">
                          <p style="margin: 0 0 5px; font-size: 11px; color: #6B7280; text-transform: uppercase;">📅 Move Date</p>
                          <p style="margin: 0; font-size: 15px; font-weight: bold; color: #1F2937;">${move_date}</p>
                        </td>
                        <td width="50%">
                          <p style="margin: 0 0 5px; font-size: 11px; color: #6B7280; text-transform: uppercase;">⏰ Arrival Time</p>
                          <p style="margin: 0; font-size: 15px; font-weight: bold; color: #1F2937;">${arrival_time}</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- From/To -->
                <tr>
                  <td style="padding: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding-bottom: 15px;">
                          <p style="margin: 0 0 5px; font-size: 11px; color: #6B7280; text-transform: uppercase;">📍 Moving From</p>
                          <p style="margin: 0; font-size: 14px; color: #1F2937;">${moving_from}</p>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 10px 0;">
                          <div style="border-left: 2px dashed #D4AF37; height: 20px; margin-left: 8px;"></div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p style="margin: 0 0 5px; font-size: 11px; color: #6B7280; text-transform: uppercase;">📍 Moving To</p>
                          <p style="margin: 0; font-size: 14px; color: #1F2937;">${moving_to}</p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Van & Crew -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <!-- Van -->
                  <td width="48%" style="background-color: #1F2937; border-radius: 10px; padding: 20px; vertical-align: top;">
                    <p style="margin: 0 0 10px; font-size: 11px; color: #9CA3AF; text-transform: uppercase; letter-spacing: 1px;">${van_size === "No Van (Crew Only)" ? "SERVICE TYPE" : "YOUR VAN"}</p>
                    <p style="margin: 0 0 5px; font-size: 16px; font-weight: bold; color: #FFFFFF;">${van_size === "No Van (Crew Only)" ? "Crew Only" : van_size}</p>
                    <p style="margin: 0 0 15px; font-size: 12px; color: #D4AF37;">${
                      van_size === "No Van (Crew Only)" ? "Labour only - No van included" :
                      van_size === "Man & Van" ? "Perfect for small moves" :
                      van_size === "3.5 Tonne Truck" ? "Suitable for 1-2 Bedroom" :
                      van_size === "Maxi Mover Van" ? "Suitable for 1-2 Bedroom" :
                      van_size === "Luton Van" ? "Suitable for Studio-1 Bedroom" :
                      van_size === "Transit Van" ? "Suitable for Studio-1 Bedroom" :
                      van_size === "LWB Van" ? "Suitable for 3-4 Bedroom" :
                      van_size === "7.5 Tonne Truck" ? "Suitable for 4+ Bedroom" :
                      van_size === "7.5t Truck" ? "Suitable for 4+ Bedroom" : ""
                    }</p>
                    <div style="text-align: center; padding: 10px;">
                      <span style="font-size: 48px;">${van_size === "No Van (Crew Only)" ? "👷" : "🚚"}</span>
                    </div>
                  </td>
                  <td width="4%"></td>
                  <!-- Crew -->
                  <td width="48%" style="background-color: #1F2937; border-radius: 10px; padding: 20px; vertical-align: top;">
                    <p style="margin: 0 0 10px; font-size: 11px; color: #9CA3AF; text-transform: uppercase; letter-spacing: 1px;">YOUR TEAM</p>
                    <p style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #FFFFFF;">${crewCount} Professional Mover${crewCount > 1 ? 's' : ''}</p>
                    <div style="text-align: center; padding: 10px;">
                      <table border="0" cellpadding="0" cellspacing="0" style="margin: 0 auto;">
                        <tr>
                          ${crewIcons}
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          ${crewRecommendationHTML}

          ${overtimePolicyHTML}

          ${customMessageHTML}

          ${multipleLocationsHTML}

          ${specialRequirementsHTML}

          <!-- What's Next -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #EFF6FF; border-radius: 10px; padding: 20px; border-left: 4px solid #2563EB;">
                <tr>
                  <td>
                    <h4 style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #1E40AF;">📋 What's Next?</h4>
                    <div style="color: #1E40AF; font-size: 14px; line-height: 1.8; white-space: pre-line;">${whats_next.split('\n').map(line => `• ${line}`).join('<br>')}</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Our Commitment -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF3C7; border-radius: 10px; padding: 20px; border-left: 4px solid #D4AF37;">
                <tr>
                  <td>
                    <h4 style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #92400E;">🤝 Our Commitment</h4>
                    <div style="color: #92400E; font-size: 14px; line-height: 1.8; white-space: pre-line;">${our_commitment.split('\n').map(line => `✓ ${line}`).join('<br>')}</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Important Notes -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEE2E2; border-radius: 10px; padding: 20px; border-left: 4px solid #DC2626;">
                <tr>
                  <td>
                    <h4 style="margin: 0 0 15px; font-size: 16px; font-weight: bold; color: #991B1B;">⚠️ Important Notes</h4>
                    <div style="color: #991B1B; font-size: 14px; line-height: 1.8; white-space: pre-line;">${important_notes.split('\n').map(line => `⚡ ${line}`).join('<br>')}</div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Bank Details -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #1F2937; border-radius: 10px; overflow: hidden;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 20px; font-size: 16px; font-weight: bold; color: #D4AF37; text-align: center;">🏦 Bank Details for Remaining Payment</h4>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 8px 0; border-bottom: 1px solid #374151;">
                          <span style="color: #9CA3AF; font-size: 12px;">Account Name</span><br>
                          <span style="color: #FFFFFF; font-size: 14px; font-weight: bold;">${bank_account_name}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; border-bottom: 1px solid #374151;">
                          <table border="0" cellpadding="0" cellspacing="0" width="100%">
                            <tr>
                              <td width="50%">
                                <span style="color: #9CA3AF; font-size: 12px;">Sort Code</span><br>
                                <span style="color: #FFFFFF; font-size: 14px; font-weight: bold;">${bank_sort_code}</span>
                              </td>
                              <td width="50%">
                                <span style="color: #9CA3AF; font-size: 12px;">Account Number</span><br>
                                <span style="color: #FFFFFF; font-size: 14px; font-weight: bold;">${bank_account_number}</span>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0;">
                          <span style="color: #9CA3AF; font-size: 12px;">Payment Reference</span><br>
                          <span style="color: #D4AF37; font-size: 14px; font-weight: bold;">${customer_name.toUpperCase().replace(/\s+/g, '-')}</span>
                        </td>
                      </tr>
                    </table>
                    <div style="background-color: #374151; border-radius: 8px; padding: 15px; margin-top: 15px; text-align: center;">
                      ${pkg.isHourly ? `
                      <p style="margin: 0 0 5px; color: #9CA3AF; font-size: 12px;">REMAINING BALANCE</p>
                      <p style="margin: 0; color: #3B82F6; font-size: 20px; font-weight: bold;">Calculated After Job Completion</p>
                      <p style="margin: 10px 0 0; color: #9CA3AF; font-size: 13px; line-height: 1.5;">
                        Your final balance will be calculated based on<br/>
                        <strong style="color: #FCD34D;">£${total_amount}/hr × Actual Hours Worked</strong>
                      </p>
                      <p style="margin: 10px 0 0; color: #10B981; font-size: 12px;">✓ Deposit of £${deposit_received} secured</p>
                      <p style="margin: 8px 0 0; color: #FCD34D; font-size: 12px; font-weight: bold;">⚠️ Payment due on job completion - cash or bank transfer</p>
                      ` : `
                      <p style="margin: 0 0 5px; color: #9CA3AF; font-size: 12px;">REMAINING BALANCE DUE ON MOVING DAY</p>
                      <p style="margin: 0; color: #10B981; font-size: 28px; font-weight: bold;">£${pending}</p>
                      <p style="margin: 10px 0 0; color: #FCD34D; font-size: 13px; font-weight: bold;">⚠️ Payment must be made on the job day or before leaving the old property</p>
                      `}
                    </div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Full Payment Button -->
          ${payment_link ? `
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <a href="${payment_link}" style="display: inline-block; background: linear-gradient(135deg, #10B981 0%, #059669 100%); color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; text-decoration: none; padding: 18px 50px; border-radius: 30px; box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);">
                      💳 Pay Full Balance Now
                    </a>
                    <p style="margin: 10px 0 0; font-size: 12px; color: #6B7280;">Secure online payment</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          ` : ''}

          <!-- Contact -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #D4AF37; border-radius: 10px; padding: 20px; text-align: center;">
                <tr>
                  <td>
                    <p style="margin: 0 0 10px; font-size: 14px; color: #000000;">Questions? We're here to help!</p>
                    <a href="tel:07440414548" style="display: inline-block; background-color: #000000; color: #FFFFFF; padding: 12px 30px; border-radius: 25px; text-decoration: none; font-weight: bold; font-size: 16px;">
                      📞 Call Thomas
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #000000; padding: 25px 40px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h4 style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #D4AF37;">
                      HomeGo Removals &amp; Packing Ltd
                    </h4>
                    <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                      Registered in England and Wales Company No. <span style="color: #D4AF37;">16811153</span>
                    </p>
                    <!-- Social + Contact Row -->
                    <table border="0" cellpadding="0" cellspacing="0" style="margin-bottom: 12px;">
                      <tr>
                        <td style="padding: 0 6px;">
                          <a href="https://facebook.com/homegoremovals" target="_blank"><img src="https://cdn-icons-png.flaticon.com/32/733/733547.png" alt="Facebook" width="20" height="20" /></a>
                        </td>
                        <td style="padding: 0 6px;">
                          <a href="https://instagram.com/homegoremovals" target="_blank"><img src="https://cdn-icons-png.flaticon.com/32/733/733558.png" alt="Instagram" width="20" height="20" /></a>
                        </td>
                        <td style="padding: 0 10px; color: #444;">|</td>
                        <td style="padding: 0 4px;">
                          <a href="https://wa.me/447440414548" style="display: inline-block; background-color: #25D366; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; text-decoration: none; padding: 5px 10px; border-radius: 12px;">WhatsApp</a>
                        </td>
                        <td style="padding: 0 4px;">
                          <a href="tel:07440414548" style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; text-decoration: none; padding: 5px 10px; border-radius: 12px;">Call Thomas</a>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #666666;">
                      &copy; HomeGo Removals &amp; Packing Ltd. All rights reserved.
                    </p>
                    <!-- Physical Address -->
                    <p style="margin: 10px 0 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888888;">
                      HomeGo Removals &amp; Packing Ltd | UK's Nationwide Premium Moving Company | Tel: 0330 043 4791
                    </p>
                    <!-- Unsubscribe -->
                    <p style="margin: 10px 0 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 9px; color: #999999;">
                      This email confirms your deposit payment. Reply with "unsubscribe" to stop receiving emails.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;
};

export default generateDepositReceivedEmailHTML;
